import { isEmpty } from 'lodash';
import styled from 'styled-components';

import { FinancialSettlementAdvancePayment } from '@dreryk/egabinet-financial-settlement-frontend-api';

import { StyledFlex, Text } from '@dreryk/react-components';

import { OnRefundSuccessCallback } from '~libs.desktop.shared.refund-advance-payment';

import { areAdvancePaymentsAvailable } from '../form/VisitSettlementForm.utils';
import { AdjustmentFormBean } from '../form/adjustment/adjustment.types';
import { VisitDetailsFormBean } from '../form/visitDetails/visitDetails.types';
import { PriceText } from '../price/PriceText';
import { TotalPriceText } from '../totalPrice/TotalPriceText';

import { VisitMedicalServiceTableBean } from './medicalServices.types';
import { getMedicalServicePrices } from './medicalServices.utils';
import { MedicalServicesPrices } from './prices/MedicalServicesPrices';

const StyledPriceText = styled(PriceText)`
   min-width: 92px;
   max-width: 92px;
   text-align: right;
   align-self: center;
`;

StyledPriceText.displayName = 'StyledPriceText';

type VisitSettlementServiceListProps = {
   readonly adjustment?: AdjustmentFormBean;
   readonly medicalServices: VisitMedicalServiceTableBean[];
   readonly advancePayments?: FinancialSettlementAdvancePayment[];
   readonly visitDetails?: VisitDetailsFormBean;
   readonly onRefundSuccess: OnRefundSuccessCallback;
};

export const VisitSettlementServiceList = (props: VisitSettlementServiceListProps): JSX.Element | null => {
   if (isEmpty(props.medicalServices)) {
      return null;
   }

   return (
      <StyledFlex direction={'column'} gap={'18px'}>
         <StyledFlex direction={'column'} gap={'4px'}>
            {props.medicalServices.map((medicalService, index) => (
               // eslint-disable-next-line react/no-array-index-key
               <StyledFlex key={index} gap={'4px'} justifyContent={'space-between'}>
                  <Text testId={'medicalServiceName'}>{medicalService.medicalService.name}</Text>
                  <StyledPriceText testId={'price'} value={medicalService.price!} stripDecimalZeroes />
               </StyledFlex>
            ))}
         </StyledFlex>
         <StyledFlex justifyContent={'flex-end'}>
            {areAdvancePaymentsAvailable(props.advancePayments) ? (
               <MedicalServicesPrices
                  adjustment={props.adjustment}
                  advancePayments={props.advancePayments}
                  medicalServicesPrices={getMedicalServicePrices(props.medicalServices)}
                  visitDetails={props.visitDetails!}
                  onRefundSuccess={props.onRefundSuccess}
               />
            ) : (
               <TotalPriceText prices={getMedicalServicePrices(props.medicalServices)} />
            )}
         </StyledFlex>
      </StyledFlex>
   );
};
